import { Checkbox } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { Col, Cols, Rows } from '~/src/dash/components/layout';
import { Text } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { IMenuList } from '~/src/dash/types/menuList';
import { DropdownValues } from '~/src/dash/views/bulk-update-channel-groups/BulkUpdateChannelGroups/BulkUpdateValues/DropdownValues';
import { IBulkUpdateChannelGroupValue } from '~/src/dash/views/bulk-update-channel-groups/config';
import { useBulkUpdateChannelGroupStore } from '~/src/dash/views/bulk-update-channel-groups/contexts';

interface IBulkUpdateValueProps extends IStore {
  handleIDSelectionAccept: (key: string, list: IMenuList) => void;
  activeFields: Record<string, boolean>;
  handleActiveFieldsToUpdate: (field: string) => void;
}

export const BulkUpdateValues = ({
  user,
  session,
  handleIDSelectionAccept,
  handleActiveFieldsToUpdate,
  activeFields,
}: IBulkUpdateValueProps) => {
  const { cfg } = useBulkUpdateChannelGroupStore();
  const { valuesToUpdate } = cfg;

  const [multipleLists, setMultipleLists] = useState<Record<string, IMenuList>>({});

  useEffect(() => {
    const tempState = {} as Record<string, IMenuList>;
    const allAPIs: Array<Promise<any>> = [];
    const allMenuTitles: string[] = [];
    Object.values(valuesToUpdate).forEach((lists: IBulkUpdateChannelGroupValue) => {
      const { isAPICall, getList, menuTitle } = lists;
      if (isAPICall && getList) {
        allAPIs.push(getList(session, user));
        allMenuTitles.push(menuTitle);
      }
    });
    Promise.all(allAPIs).then((allData) => {
      allData.forEach((data: IMenuList, idx) => {
        tempState[allMenuTitles[idx]] = data;
      });
      setMultipleLists(tempState);
    });
  }, []);

  return (
    <Col>
      {multipleLists &&
        Object.keys(multipleLists).map((key) => (
          <Rows>
            {valuesToUpdate[key].description && <Text>{valuesToUpdate[key].description}</Text>}
            <Cols>
              <Checkbox
                onClick={() => handleActiveFieldsToUpdate(key)}
                checked={!!activeFields[key]}
              />
              <DropdownValues
                menuTitle={valuesToUpdate[key].menuTitle}
                singularTitle={valuesToUpdate[key].singularTitle}
                list={multipleLists[key]}
                handleIDSelectionAccept={handleIDSelectionAccept}
                activeFields={activeFields}
              />
            </Cols>
          </Rows>
        ))}
    </Col>
  );
};
